__turbopack_context__.v({
  "starIcon": "PxcjLa_starIcon",
});
